import { createApp } from 'vue';
import VideoDialog from 'ewi-ui/components/2-molecules/VideoDialog/VideoDialog.vue';

let videoDialogElements = document.getElementsByClassName('vue-video-dialog');

for (let i = 0; i < videoDialogElements.length; i++) {
  let config = videoDialogElements[i].dataset;
  const app = createApp(VideoDialog, {
    youtubeId: config.youtube,
    videos: JSON.parse(config.videos),
    component_id: i,
  });
  app.mount(videoDialogElements[i]);
}
